import { Validators } from 'core/services/Validators';
import { computed, makeObservable } from 'mobx';
import { FormControl } from 'shared/libs/form';
import { HttpClient } from 'shared/libs/http';
import { AsyncState } from 'shared/libs/state';
import { ApplyJobStore } from '../ApplyJob.store';
import { CodeConfirmSuccessDto } from './types';

export class ConfirmCodeStore {
   private readonly confirmEmeilOrPhoneState = new AsyncState<CodeConfirmSuccessDto>();

   readonly codeControl = new FormControl<string>('', [Validators.required]);

   constructor(private readonly applyJobStore: ApplyJobStore) {
      makeObservable(this, {
         processing: computed,
      });
   }

   get processing(): boolean {
      return this.confirmEmeilOrPhoneState.status === 'pending';
   }

   confirmEmailOrPhone = async ({
      onSuccess,
      onError,
   }: { onSuccess?: (res: CodeConfirmSuccessDto) => void; onError?: (err?: any) => void } = {}) => {
      const email = this.applyJobStore.registerOrLogin.form.controls['email_address'].value;
      const contact = this.applyJobStore.registerOrLogin.form.controls['contact'].value;

      await this.confirmEmeilOrPhoneState.run(
         () =>
            HttpClient.post('/jobApply/code', {
               code: this.codeControl.value?.trim(),
               email_address: email,
               contact: contact,
               city_id: this.applyJobStore.registerOrLogin.form.controls['city_id'].value,
               birthday: this.applyJobStore.registerOrLogin.form.controls['birthday'].value,
            }),
         {
            onSuccess: (res) => {
               if (res.status === 200) {
                  onSuccess?.(res);
               } else {
                  this.codeControl.setError('Ви ввели невірний код, спробуйте ще раз.');
                  onError?.();
               }
            },
            onError: (e) => {
               onError?.(e);
            },
         }
      );
   };
}
